<template>
  <div class="bgc score">
    <!-- <Loading v-if="loading" /> -->
    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
    </div>
    <!-- <gaid v-if="loading" /> -->
    <div class="table_div">
      <NotData v-show="!isShow" />
      <div v-show="isShow" :id="id" class="echarts"></div>
    </div>
  </div>
</template>

<script>
  import axios from '@utils'
  import * as echarts from 'echarts'
  // import Loading from '@comp/loading'
  export default {
    name: 'Quartile',
    components: {
      // Loading
    },
    props: {
      itemTitle: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        splitNum: 7,
        data: {},
        isShow: true,
        charts: null
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.meId) {
            this.getquartilelist()
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      // this.getquartilelist()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      //获取四分位
      getquartilelist() {
        const _this = this
        let {
          seId,
          meId,
          dId,
          examIsActive = 1,
          classId,
          campusId
        } = this.$route.query
        let unionUrl = [
          'getquartilelist',
          'getquartilelistUnion',
          'getquartilelistSchoolUnion'
        ]
        let params = {
          meId,
          classId,
          seId,
          dId,
          campusId
        }
        axios({
          url: unionUrl[examIsActive],
          params,
          loading: false,
          getCache: this.cache,
          cacheData: true
        }).then(res => {
          let { xTitle, yTitle, avgScore } = res.data
          this.data = res.data
          this.$set(this, 'isShow', true)
          this.isShow = xTitle.length ? true : false
          _this.$nextTick(() => {
            _this.classDataF(xTitle, yTitle, avgScore)
          })
        })
      },
      /**
       * 四分位分析
       * @param xTitle
       * @param yTitle
       * @param avgScore
       */
      classDataF(xTitle, yTitle, avgScore) {
        let _this = this
        let yTitles = yTitle.flat()
        let dataList = yTitle.map(item => {
          if (!item) {
            item = []
          }
          let cMaxNum = Math.max(...item)
          let cMinNum = Math.min(...item)
          //初始化默认值
          let yAndC = {
            colorA: '#69D4AA',
            colorB: '#FF8484',
            offset: 1
          }
          if (cMaxNum - avgScore < 0) {
            //低于平均值
            yAndC.colorA = '#FF8484'
            yAndC.colorB = '#FF8484'
          } else if (cMaxNum - avgScore >= 0 && cMinNum >= avgScore) {
            //高于平均值
            yAndC.colorA = '#69D4AA'
            yAndC.colorB = '#69D4AA'
          } else {
            //高低介于均值之间
            let height = cMaxNum - cMinNum //当前箱线图高度
            let avgCz = cMaxNum - avgScore //当前箱线图与平均值的高度差
            let splitVal = +(avgCz / height).toFixed(2) //高于平均值比例
            yAndC.offset = splitVal
          }

          let obj = {
            value: item,
            itemStyle: {
              borderColor: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: yAndC.colorA // 0% 处的颜色
                  },
                  {
                    offset: yAndC.offset,
                    color: yAndC.colorA
                  },
                  {
                    offset: yAndC.offset,
                    color: yAndC.colorB
                  },
                  {
                    offset: 1,
                    color: yAndC.colorB // 100% 处的颜色
                  }
                ]
              }
            }
          }
          return obj
        })

        this.charts = echarts.init(document.getElementById(this.id))
        let chartObj = {
          grid: {
            top: 30
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#ddeeff'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px)',
            formatter: function(param) {
              let data = param[0].data
              return (
                `<p class="toolTip" style="color:#69D4AA">${_this.$t(
                  'exam.maxScore'
                )}：${data.value[5]}</p>` +
                `<p class="toolTip">${_this.$t('exam.scoreLine1')}：${
                  data.value[2]
                }</p>` +
                `<p class="toolTip">${_this.$t('exam.scoreLine2')}：${
                  data.value[3]
                }</p>` +
                `<p class="toolTip">${_this.$t('exam.scoreLine3')}：${
                  data.value[4]
                }</p>` +
                `<p class="toolTip" style="color:#FF8484">${_this.$t(
                  'exam.minScore'
                )}：${data.value[1]}</p>`
              )
            }
          },
          yAxis: {
            name: _this.$t('exam.scoreNum'),
            nameTextStyle: {
              color: '#333'
            }
          },
          xAxis: {
            type: 'category',
            data: xTitle,
            boundaryGap: true,
            name: _this.$store.state.unionReport
              ? _this.$t('exam.titleschool')
              : _this.$t('exam.label3'),
            nameTextStyle: {
              color: '#333'
            }
          },
          series: [
            {
              name: _this.$t('exam.scoreNum'),
              type: 'boxplot',
              data: dataList,
              markLine: {
                symbol: ['none', 'arrow'],
                data: [
                  {
                    type: 'average',
                    name: _this.$t('exam.average'),
                    yAxis: avgScore
                  }
                ],
                lineStyle: {
                  color: '#FF8484'
                }
              }
            }
          ]
        }

        this.beforeEchart(chartObj, yTitles)
        this.cScroll(chartObj, xTitle, 10)
        this.charts.setOption(chartObj)
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null,
          person = false
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 40 + 24
        }
        //echarts距离处理
        let yName = data.yAxis && data.yAxis.name
        if (!data.grid) data.grid = {}
        if (!data.grid.top) data.grid.top = data.legend ? top : yName ? 44 : 34
        if (!data.grid.bottom) data.grid.bottom = 26
        if (!data.grid.left) data.grid.left = '3.5%'
        if (!data.grid.right) data.grid.right = 50

        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            if (!item.axisLabel) item.axisLabel = {}
            item.axisLabel.textStyle = {
              fontFamily: 'PingFangSC, PingFangSC-Regular',
              color: '#666666',
              fontSize: 14
            }
            item.axisTick = {
              show: false
            }
          })
        } else {
          if (!data.xAxis.axisLabel) data.xAxis.axisLabel = {}
          data.xAxis.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          data.xAxis.axisTick = {
            show: false
          }
          !data.xAxis.offset && (data.xAxis.offset = 4)
          if (!data.xAxis.axisLine) {
            data.xAxis.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['rgba(60, 100, 239, 0.1)', '#fff'],
                opacity: 0.3
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            // 人数展示整数
            if (person) {
              if (splitVal % 1) {
                let num = splitVal % 1
                max += splitNum * (1 - num)
              }
              data.yAxis.minInterval = 1
              data.yAxis.interval = max / splitNum
            }
            if (!person) {
              data.yAxis.interval = splitVal
            }
            data.yAxis.max = max

            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = function(value) {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length > num) {
          let endVal = +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              handleIcon: `M 100, 100
                                m -75, 0
                                a 75,75 0 1,0 150,0
                                a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              xAxisIndex: [0],
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: 'rgba(203, 214, 255, 0.6)', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    .table_div {
      min-height: 400px;
      .echarts {
        height: 400px;
      }
    }
  }
</style>
